import { render } from "./IconAlignTextCenter.vue?vue&type=template&id=e91080fa"
import script from "./IconAlignTextCenter.vue?vue&type=script&lang=js"
export * from "./IconAlignTextCenter.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__